import React, { Component } from 'react';
import { withFirebase } from '../Firebase';
import { withRouter } from 'react-router-dom';
import './SearchPage.css'
import PeerLine from '../PeerLine/PeerLine';
import TeamLine from '../TeamLine/TeamLine';
import CardCarousel from '../Card/BasicCardCarousel';
import CreateCapsule from '../Home/ButtonCreate';
import * as firebase from 'firebase';


class SearchPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "", pollsSearch: [], capsulesTeamSearch: [],
      capsulesPeersSearch: [], typing: false, typingTimeout: 0,
      current_uid: "", capsules_team: [], capsules_peers: [],
      capsules: [], current_user: {}, myAssignments: [],
      queryTeam: [], queryPeers: [], snackbarUpDownOpen: false,
    }
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    document.body.style.background = '#F8F9FB';

    let uid;
    let capsules_team;
    let capsules_peers;
    let cu;

    if (this.props.firebase.auth.currentUser) {
      uid = this.props.firebase.auth.currentUser.uid
      this.setState({ current_uid: uid })

      this.props.firebase.db
        .collection('assignments').where('targetUser', '==', uid)
        .where('accepted', '==', 'null').get().then((doc) => {
          if (doc.exists) {
            this.setState({ myAssignments: doc.data() });
          } else {
            console.error("No such document!");
          }
        })


      this.props.firebase.db
        .collection("users")
        .doc(uid)
        .get()
        .then((doc) => {
          if (doc.exists) {
            cu = doc.data();

            this.setState({ current_user: cu });
          } else {
            console.error("No such document!");
          }
        }).then(() => {
          this.props.firebase.db.collection('capsules').where('managers', 'array-contains', cu.manager).get()
            .then(querysnapshot => {
              capsules_peers = querysnapshot.docs.map(doc => {
                let data = doc.data()
                return {
                  id: doc.id,
                  ...data
                }
              });
              this.setState({ capsules_peers: capsules_peers, queryPeers: querysnapshot.docs })
            });
        }).then(() => {
          this.props.firebase.db.collection('capsules').where('managers', 'array-contains', uid).get()
            .then(querysnapshot => {
              capsules_team = querysnapshot.docs.map(doc => {
                let data = doc.data()
                return {
                  id: doc.id,
                  ...data
                }
              });
              let concatList = capsules_team.concat(capsules_peers);
              this.setState({ capsules_team: capsules_team, capsules: concatList, queryTeam: querysnapshot.docs })
            });
        })
    }
  }

  onChange = (event) => {
    const self = this;

    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }

    self.setState({
      search: event.target.value,
      typing: false,
      typingTimeout: setTimeout(function () {
        self.searchResult(self.state.search);
      }, 1500)
    });
    this.setState({ [event.target.name]: event.target.value });
  }

  searchResult = (search) => {
    const { capsules_peers, capsules_team, capsules } = this.state
    let matchingCapsulesPeers = capsules_peers.filter(capsule => (capsule.title.toLowerCase().includes(search.toLowerCase()) || capsule.description.toLowerCase().includes(search.toLowerCase())))
    let matchingCapsulesTeam = capsules_team.filter(capsule => (capsule.title.toLowerCase().includes(search.toLowerCase()) || capsule.description.toLowerCase().includes(search.toLowerCase())))
    let matchingPolls = capsules.filter(capsule => (capsule.tags.includes(search.toLowerCase())))
    this.setState({ capsulesTeamSearch: matchingCapsulesTeam, capsulesPeersSearch: matchingCapsulesPeers, pollsSearch: matchingPolls });
  }

  searchBar = () => {

    return (
      <div className="background-search text-center">
        <input
          className="search-bar mt-3 border-none"
          name="search"
          type="text"
          onChange={this.onChange}
          placeholder="Recherche"
        />
      </div>
    )
  }

  openSnackbar = () => {
    this.setState({ snackbarUpDownOpen: true });
  };

  closeSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    this.setState({ snackbarUpDownOpen: false, needToRemoveIfUndo: false });
  };

  upCapsule = async (capsuleID) => {
    let querySnapshotCapsule = await this.props.firebase.db.collection('capsules').doc(capsuleID).get()
    let managers = querySnapshotCapsule.data().managers
    this.setState({
      currentCapsuleId: capsuleID,
      action: 'up',
      needToRemoveIfUndo: !managers.includes(this.state.managerID)
    })

    await this.props.firebase.db.collection('capsules').doc(capsuleID).update({
      managers: firebase.firestore.FieldValue.arrayUnion(this.state.managerID)
    })

    this.openSnackbar();

  }

  downCapsule = async (capsuleID) => {
    let querySnapshotCapsule = await this.props.firebase.db.collection('capsules').doc(capsuleID).get()
    let managers = querySnapshotCapsule.data().managers
    this.setState({
      currentCapsuleId: capsuleID,
      action: 'down',
      needToRemoveIfUndo: !managers.includes(this.props.firebase.auth.currentUser.uid)
    })
    await this.props.firebase.db.collection('capsules').doc(capsuleID).update({
      managers: firebase.firestore.FieldValue.arrayUnion(this.props.firebase.auth.currentUser.uid)
    })
    this.openSnackbar();
  }

  undoUpDown = async () => {
    const { action, currentCapsuleId, needToRemoveIfUndo } = this.state
    if (needToRemoveIfUndo) {
      if (action === 'up') {
        await this.props.firebase.db.collection('capsules').doc(currentCapsuleId).update({
          managers: firebase.firestore.FieldValue.arrayRemove(this.state.managerID)
        })
        this.closeSnackbar();
      }
      else {
        const currentCapsuleId = this.state.currentCapsuleId;
        await this.props.firebase.db.collection('capsules').doc(currentCapsuleId).update({
          managers: firebase.firestore.FieldValue.arrayRemove(this.props.firebase.auth.currentUser.uid)
        })
        this.closeSnackbar();
      }
    }
    this.closeSnackbar();
  }

  render() {
    return (
      <>
        {this.searchBar()}
        <div className="mt-4"></div>
        <PeerLine myAssignments={this.state.myAssignments} />
        <CardCarousel data={this.state.capsulesPeersSearch}
          direction={'down'}
          upCapsule={this.upCapsule}
          downCapsule={this.downCapsule}
          undo={this.undoUpDown}
          snackbarUpDownOpen={this.state.snackbarUpDownOpen}
          closeSnackbar={this.closeSnackbar}
          messageSnackBar={this.state.action === 'up' ? "Capsule remontée" : "Capsule descendue"}
          fromSearchPage={true} />
        <TeamLine />
        <CardCarousel data={this.state.capsulesTeamSearch}
          direction={'up'}
          upCapsule={this.upCapsule}
          downCapsule={this.downCapsule}
          undo={this.undoUpDown}
          snackbarUpDownOpen={this.state.snackbarUpDownOpen}
          closeSnackbar={this.closeSnackbar}
          messageSnackBar={this.state.action === 'up' ? "Capsule remontée" : "Capsule descendue"}
          fromSearchPage={true} />
        <CreateCapsule />
      </>
    )
  }
}


const SearchPageBase = withRouter(withFirebase(SearchPage));
export default SearchPageBase;